import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ColumnTypeEnum, OperatorEnum } from '@y42/json-schema';
import { filter, map, merge, pairwise, tap } from 'rxjs';
import { OperationInputFormService } from '../../operation-input-form.service';

@UntilDestroy()
@Component({
  selector: 'y42-operation-input-add[columnType][defaultOperator][index]',
  templateUrl: './operation-input-add.component.html',
  styleUrls: ['./operation-input-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputAddComponent {
  constructor(private readonly formService: OperationInputFormService, private readonly cdRef: ChangeDetectorRef) {
    const changedOpsArrayLength$ = this.formService.operationsFormArray.valueChanges.pipe(
      pairwise(),
      map(([prev, curr]) => prev.length !== curr.length),
      filter(Boolean),
    );

    merge(changedOpsArrayLength$, this.formService.reset$)
      .pipe(
        tap(() => this.cdRef.markForCheck()),
        untilDestroyed(this),
      )
      .subscribe();
  }

  @Input() columnType!: ColumnTypeEnum;
  @Input() defaultOperator!: OperatorEnum;
  @Input() enableMoreConditions = true;
  @Input() index!: number;

  readonly operationsFormArray = this.formService.operationsFormArray;

  addOperation() {
    this.formService.addOperation(this.columnType, this.defaultOperator);
    this.cdRef.markForCheck();
  }
}
